// extracted by mini-css-extract-plugin
module.exports = {"video":"YoutubeEmbed_video__JgIbB","iframe":"YoutubeEmbed_iframe__AW_0f"};